export default function reducer(
  state = {
    status: "",
    error: null,
    user: {
      cardId: null,
      email: null,
      id: null,
      name: null,
      picture: {
        link: null
      },
      updated: {
        uid: false,
        picture: false,
        link: false,
        contact: false,
        password: false
      },
      status: {
        error: 'info',
        message: ''
      }
    },
    users: {
      admins: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1
        }
      },
      officers: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1
        }
      },
      marshals: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1
        }
      }
    }
  },
  action
) {

  let data
  switch (action.type) {
    case "CLEAR_STORE":
      state = defaultState()
      break;
    case "ENDUSER_ONLINE_INFO":
      data = action.payload.data
      state = {
        ...state,
        error: null,
        status: "ENDUSER_ONLINE_INFO",
        user: { ...state.user, ...data }
      }
      break;
    case "ENDUSERS_UPDATECARD_FULFILLED":
      state = endusers_updateCard_fulfilled(state, action.payload.data)
      break;
    case "ENDUSERS_UPDATECARD_REJECTED":
      state = endusers_updateCard_rejected(state, action.payload.data)
      break;
    case "ENDUSERS_CARDUIDALERT_DISMISSS":
      state = endusers_updateCard_dismissAlert(state)
      break;
    case "ENDUSERS_UPDATECONTACT_FULFILLED":
      state = endusers_updateContact_fulfilled(state, action.payload.data)
      break;
    case "ENDUSERS_UPDATECONTACT_REJECTED":
      state = endusers_updateContact_rejected(state, action.payload.data)
      break;
    case "ENDUSERS_CONTACTALERT_DISMISSS":
      state = endusers_updateContact_dismissAlert(state)
      break;
    case "ENDUSERS_PASSWORD_MISMATCHED":
      state = endusers_password_mismatched(state)
      break;
    case "ENDUSERS_PASSWORD_LENGTH_ERR":
      state = endusers_password_lengthErr(state)
      break;
    case "ENDUSERS_PASSWORDALERT_DISMISSS":
      state = endusers_updatePassword_dismissAlert(state)
      break;
    case "ENDUSERS_PASSWORD_FULFILLED":
      state = endusers_password_fulfilled(state)
      break;
    case "ENDUSERS_PASSWORD_REJECTED":
      state = endusers_password_rejected(state, action.payload.data)
      break;
    case "ENDUSERS_UPDATE_PROFILEPIC":
      state = endusers_update_profilePic(state, action.payload)
      break;
    case "ENDUSERS_RESET_PROFILEPIC":
      state = endusers_reset_profilePic(state)
      break;
    case "ENDUSERS_UPLOADPIC_REJECTED":
      state = endusers_picture_uploadErr(state, "Failed to upload picture")
      break;
    case "ENDUSERS_UPDATEPIC_REJECTED":
      state = endusers_picture_uploadErr(state, "Failed to update picture")
      break;
    case "ENDUSERS_UPDATEPIC_FULFILLED":
      state = endusers_updatepic_fulfilled(state, action.payload)
      break;
    case "ENDUSERS_PICTURE_DISMISSS":
      state = endusers_updatePicture_dismissAlert(state)
      break;
    case "ENDUSERS_USERLIST_FULFILLED":
      state = endusers_userlist_fulfilled(state, action.payload)
      break;
    case "ENDUSERS_USERLIST_CLEAR":
      state = endusers_userlist_clear(state)
      break;
    case "ENDUSERS_ADMINPAGECOUNT_CHANGE":
      state = endusers_adminPageCount_change(state, action.payload)
      break;
    case "ENDUSERS_ADMINPAGE_CHANGE":
      state = endusers_adminPage_change(state, action.payload)
      break;
    case "ENDUSERS_OFFICERPAGECOUNT_CHANGE":
      state = endusers_officerPageCount_change(state, action.payload)
      break;
    case "ENDUSERS_OFFICERPAGE_CHANGE":
      state = endusers_officerPage_change(state, action.payload)
      break;
    case "ENDUSERS_MARSHALPAGECOUNT_CHANGE":
      state = endusers_marshalPageCount_change(state, action.payload)
      break;
    case "ENDUSERS_MARSHALPAGE_CHANGE":
      state = endusers_marshalPage_change(state, action.payload)
      break;
    case "ENDUSERS_ADMINS_FILTERED":
      state = endusers_adminpagination(state, action.payload)
      break;
    case "ENDUSERS_OFFICERS_FILTERED":
      state = endusers_officerpagination(state, action.payload)
      break;
    case "ENDUSERS_MARSHALS_FILTERED":
      state = endusers_marshalpagination(state, action.payload)
      break;
    default:
      return state;
  }
  return state;
}

function defaultState() {
  return {
    status: "",
    error: null,
    user: {
      cardId: null,
      email: null,
      id: null,
      name: null,
      picture: {
        link: null
      },
      updated: {
        uid: false,
        picture: false,
        link: false,
        contact: false,
        password: false
      },
      status: {
        error: 'info',
        message: ''
      }
    },
    users: {
      admins: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1
        }
      },
      officers: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1
        }
      },
      marshals: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1
        }
      }
    }
  }
}


function endusers_updateCard_fulfilled(state, card) {
  let { user, ..._state } = state
  let { updated, status, ..._user } = user

  let _status = {
    ...status,
    error: 'info',
    message: 'Card UID successfully updated'
  }
  let _updated = {
    ...updated,
    uid: true
  }
  _user = {
    ..._user,
    cardId: card.cardId,
    status: _status,
    updated: _updated
  }
  _state = { ..._state, user: _user }
  return _state
}
function endusers_updateCard_rejected(state, card) {

  let { user, ..._state } = state
  let { updated, status, ..._user } = user

  let _status = {
    ...status,
    error: 'danger',
    message: `${card.error.name} : ${card.error.message}`
  }
  let _updated = {
    ...updated,
    uid: true
  }
  _user = {
    ..._user,
    status: _status,
    updated: _updated
  }
  _state = { ..._state, user: _user }

  return _state
}

function endusers_updateContact_fulfilled(state, contact) {
  let { user, ..._state } = state
  let { updated, status, ..._user } = user

  let _status = {
    ...status,
    error: 'info',
    message: 'Contact successfully updated'
  }
  let _updated = {
    ...updated,
    contact: true
  }
  _user = {
    ..._user,
    phoneNumber: contact.phoneNumber,
    status: _status,
    updated: _updated
  }
  _state = { ..._state, user: _user }
  return _state
}
function endusers_updateContact_rejected(state, contact) {

  let { user, ..._state } = state
  let { updated, status, ..._user } = user

  let _status = {
    ...status,
    error: 'danger',
    message: `${contact.error.name} : ${contact.error.message}`
  }
  let _updated = {
    ...updated,
    contact: true
  }
  _user = {
    ..._user,
    status: _status,
    updated: _updated
  }
  _state = { ..._state, user: _user }

  return _state
}

function endusers_password_mismatched(state) {
  let { user, ..._state } = state
  let { updated, status, ..._user } = user

  let _status = {
    ...status,
    error: 'danger',
    message: 'Password mismatched'
  }
  let _updated = {
    ...updated,
    password: true
  }
  _user = {
    ..._user,
    status: _status,
    updated: _updated
  }
  _state = { ..._state, user: _user }
  return _state;
}
function endusers_password_lengthErr(state) {
  let { user, ..._state } = state
  let { updated, status, ..._user } = user

  let _status = {
    ...status,
    error: 'danger',
    message: 'Password length must be more than 6 characters'
  }
  let _updated = {
    ...updated,
    password: true
  }
  _user = {
    ..._user,
    status: _status,
    updated: _updated
  }
  _state = { ..._state, user: _user }
  return _state;
}

function endusers_password_fulfilled(state) {
  let { user, ..._state } = state
  let { updated, status, ..._user } = user

  let _status = {
    ...status,
    error: 'success',
    message: 'Password successfully updated'
  }
  let _updated = {
    ...updated,
    password: true
  }
  _user = {
    ..._user,
    status: _status,
    updated: _updated
  }
  _state = { ..._state, user: _user }
  return _state;
}
function endusers_password_rejected(state, resp) {
  let { user, ..._state } = state
  let { updated, status, ..._user } = user

  let _status = {
    ...status,
    error: 'danger',
    message: `${resp.error.name} : ${resp.error.message}`
  }
  let _updated = {
    ...updated,
    password: true
  }
  _user = {
    ..._user,
    status: _status,
    updated: _updated
  }
  _state = { ..._state, user: _user }

  return _state
}

function endusers_updateCard_dismissAlert(state) {
  let { user, ..._state } = state
  let { updated, ..._user } = user

  let _updated = {
    ...updated,
    uid: false
  }
  _user = {
    ..._user,
    updated: _updated
  }
  _state = { ..._state, user: _user }
  return _state
}
function endusers_updateContact_dismissAlert(state) {
  let { user, ..._state } = state
  let { updated, ..._user } = user

  let _updated = {
    ...updated,
    contact: false
  }
  _user = {
    ..._user,
    updated: _updated
  }
  _state = { ..._state, user: _user }
  return _state
}
function endusers_updatePassword_dismissAlert(state) {
  let { user, ..._state } = state
  let { updated, ..._user } = user

  let _updated = {
    ...updated,
    password: false
  }
  _user = {
    ..._user,
    updated: _updated
  }
  _state = { ..._state, user: _user }
  return _state
}
function endusers_updatePicture_dismissAlert(state) {
  let { user, ..._state } = state
  let { updated, ..._user } = user

  let _updated = {
    ...updated,
    picture: false
  }
  _user = {
    ..._user,
    updated: _updated
  }
  _state = { ..._state, user: _user }
  return _state
}

function endusers_update_profilePic(state, pic) {
  let { user, ..._state } = state
  let { picture, ..._user } = user

  let _picture = {
    ...picture,
    preview: pic
  }

  _user = {
    ..._user,
    picture: _picture
  }
  _state = {
    ..._state,
    user: _user
  }
  return _state
}
function endusers_reset_profilePic(state) {
  if (typeof (state.user.picture.preview) === 'undefined') {
    return state;
  }
  let { user, ..._state } = state
  let { picture, ..._user } = user
  /* eslint-disable no-unused-vars*/
  let { preview, ..._picture } = picture
  /* eslint-enable no-unused-vars*/

  _user = {
    ..._user,
    picture: _picture
  }
  _state = {
    ..._state,
    user: _user
  }
  return _state
}

function endusers_updatepic_fulfilled(state, result) {
  let { user, ..._state } = state
  let { picture, status, updated, ..._user } = user
  /*eslint-disable no-unused-vars */
  let { preview, ..._picture } = picture
  /*eslint-enable no-unused-vars */
  let _status = {
    ...status,
    error: 'success',
    message: 'Profile picture updated'
  }
  let _updated = {
    ...updated,
    picture: true
  }
  _picture = {
    ..._picture,
    filename: result.endusers.filename,
    link: result.endusers.link
  }
  _user = {
    ..._user,
    picture: _picture,
    status: _status,
    updated: _updated
  }
  _state = {
    ..._state,
    user: _user
  }
  return _state
}
function endusers_picture_uploadErr(state, msg) {
  let { user, ..._state } = state
  let { updated, status, ..._user } = user

  let _status = {
    ...status,
    error: 'danger',
    message: msg
  }
  let _updated = {
    ...updated,
    picture: true
  }
  _user = {
    ..._user,
    status: _status,
    updated: _updated
  }
  _state = { ..._state, user: _user }

  return _state
}

function endusers_userlist_fulfilled(state, __users) {
  let { users, ..._state } = state
  let { admins, officers, marshals, ..._users } = users

  if (typeof (__users.admins) !== 'undefined') {
    admins = normalize_admins(__users.admins)
  } else {
    admins = {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    }
  }
  if (typeof (__users.officers) !== 'undefined') {
    officers = normalize_officers(__users.officers)
  } else {
    officers = {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    }
  }

  if (typeof (__users.marshals) !== 'undefined') {
    marshals = normalize_marshals(__users.marshals)
  } else {
    marshals = {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    }
  }

  _users = {
    ..._users,
    admins: admins,
    officers: officers,
    marshals: marshals
  }
  _state = {
    ..._state,
    users: _users
  }
  return _state
}
function endusers_userlist_clear(state) {
  let { users, ..._state } = state
  users = {
    admins: {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    },
    officers: {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    },
    marshals: {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      }
    }
  }
  _state = {
    ..._state,
    users: users
  }
  return _state
}
function normalize_admins(admins) {
  let _admins = {
    byid: {},
    list: [],
    pagination: {
      count: admins.length,
      total: admins.length,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: Math.ceil(admins.length / 10)
    }
  }
  admins.forEach(admin => {
    _admins.byid[admin.id] = admin
    _admins.list.push(admin.id)
  });
  return _admins
}
function normalize_officers(officers) {
  let _officers = {
    byid: {},
    list: [],
    pagination: {
      count: officers.length,
      total: officers.length,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: Math.ceil(officers.length / 10)
    }
  }
  officers.forEach(officer => {
    _officers.byid[officer.id] = officer
    _officers.list.push(officer.id)
  });
  return _officers
}
function normalize_marshals(marshals) {
  let _marshals = {
    byid: {},
    list: [],
    pagination: {
      count: marshals.length,
      total: marshals.length,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: Math.ceil(marshals.length / 10)
    }
  }
  marshals.forEach(marshal => {
    _marshals.byid[marshal.id] = marshal
    _marshals.list.push(marshal.id)
  });
  return _marshals
}

function endusers_adminPageCount_change(state, count) {
  let { users, ..._state } = state
  let { admins, ..._users } = users
  let { pagination, ..._admins } = admins

  let _pagination = {
    ...pagination,
    itemPerPage: count,
    pageCount: Math.ceil(pagination.total / count),
    currentPage: 1
  }

  _admins = {
    ..._admins,
    pagination: _pagination
  }
  _users = {
    ..._users,
    admins: _admins
  }
  _state = {
    ..._state,
    users: _users
  }
  return _state
}
function endusers_adminPage_change(state, index) {
  let { users, ..._state } = state
  let { admins, ..._users } = users
  let { pagination, ..._admins } = admins
  let _pagination = {
    ...pagination,
    currentPage: index
  }

  _admins = {
    ..._admins,
    pagination: _pagination
  }
  _users = {
    ..._users,
    admins: _admins
  }
  _state = {
    ..._state,
    users: _users
  }
  return _state
}

function endusers_officerPageCount_change(state, count) {
  let { users, ..._state } = state
  let { officers, ..._users } = users
  let { pagination, ..._officers } = officers

  let _pagination = {
    ...pagination,
    itemPerPage: count,
    pageCount: Math.ceil(pagination.total / count),
    currentPage: 1
  }

  _officers = {
    ..._officers,
    pagination: _pagination
  }
  _users = {
    ..._users,
    officers: _officers
  }
  _state = {
    ..._state,
    users: _users
  }
  return _state
}
function endusers_officerPage_change(state, index) {
  let { users, ..._state } = state
  let { officers, ..._users } = users
  let { pagination, ..._officers } = officers
  let _pagination = {
    ...pagination,
    currentPage: index
  }

  _officers = {
    ..._officers,
    pagination: _pagination
  }
  _users = {
    ..._users,
    officers: _officers
  }
  _state = {
    ..._state,
    users: _users
  }
  return _state
}

function endusers_marshalPageCount_change(state, count) {
  let { users, ..._state } = state
  let { marshals, ..._users } = users
  let { pagination, ..._marshals } = marshals

  let _pagination = {
    ...pagination,
    itemPerPage: count,
    pageCount: Math.ceil(pagination.total / count),
    currentPage: 1
  }

  _marshals = {
    ..._marshals,
    pagination: _pagination
  }
  _users = {
    ..._users,
    marshals: _marshals
  }
  _state = {
    ..._state,
    users: _users
  }
  return _state
}
function endusers_marshalPage_change(state, index) {
  let { users, ..._state } = state
  let { marshals, ..._users } = users
  let { pagination, ..._marshals } = marshals
  let _pagination = {
    ...pagination,
    currentPage: index
  }

  _marshals = {
    ..._marshals,
    pagination: _pagination
  }
  _users = {
    ..._users,
    marshals: _marshals
  }
  _state = {
    ..._state,
    users: _users
  }
  return _state
}

function endusers_adminpagination(state, total) {
  let { users } = state
  let { admins } = users
  let { pagination } = admins
  pagination = {
    ...pagination,
    count: total,
    currentPage: 1,
    itemPerPage: 10,
    pageCount: Math.ceil(total / 10),
    total: total
  }
  admins = {
    ...admins,
    pagination: pagination
  }
  users = {
    ...users,
    admins: admins
  }
  state = {
    ...state,
    users: users
  }
  return state
}
function endusers_officerpagination(state, total) {
  let { users } = state
  let { officers } = users
  let { pagination } = officers
  pagination = {
    ...pagination,
    count: total,
    currentPage: 1,
    itemPerPage: 10,
    pageCount: Math.ceil(total / 10),
    total: total
  }
  officers = {
    ...officers,
    pagination: pagination
  }
  users = {
    ...users,
    officers: officers
  }
  state = {
    ...state,
    users: users
  }
  return state
}
function endusers_marshalpagination(state, total) {
  let { users } = state
  let { marshals } = users
  let { pagination } = marshals
  pagination = {
    ...pagination,
    count: total,
    currentPage: 1,
    itemPerPage: 10,
    pageCount: Math.ceil(total / 10),
    total: total
  }
  marshals = {
    ...marshals,
    pagination: pagination
  }
  users = {
    ...users,
    marshals: marshals
  }
  state = {
    ...state,
    users: users
  }
  return state
}


// WEBPACK FOOTER //
// ./src/redux/reducers/_endusers.js